import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_CANDIDATE_UNLOCK_LIST_EXPORT } from "../../../common/URLs";

export const fetchEmployerCandidateUnlockListExport = async () => {
    try {
        const url = new URL(`${BASE_URL}/${EMPLOYER}/${EMPLOYER_CANDIDATE_UNLOCK_LIST_EXPORT}`);

        const token = await fetchToken();

        // console.log('API URL:', url.toString());
        // console.log('Token:', token ? 'Token exists' : 'No token found');

        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(url.toString(), {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        });

        // console.log('Response status:', response.status);

        if (!response.ok) {
            let errorData;
            try {
                errorData = await response.json();
                // console.log('Error response data:', errorData);
            } catch (e) {
                console.warn('Failed to parse error response:', e);
            }

            const errorMessage = errorData?.message ||
                errorData?.response ||
                `Server Error: ${response.status} ${response.statusText}`;

            throw new Error(errorMessage);
        }

        const data = await response.json();
        // console.log('API Response:', data);

        if (!data) {
            throw new Error('No data received from server');
        }

        return data;

    } catch (error) {
        console.error("Error in fetchEmployerCandidateUnlockListExport:", error);
        throw error;
    }
};
